// extracted by mini-css-extract-plugin
export default {"btn-add-new":"ManageCategory_btn-add-new__sCJnB","manage-category-container":"ManageCategory_manage-category-container__QNjPl","title":"ManageCategory_title__f8ABQ"};